
/**
 * Redux action to signal a color scheme change in the app/sdk.
 *
 * {
 *     type: SET_COLOR_SCHEME
 *     colorScheme: Object
 * }.
 */
export const SET_COLOR_SCHEME = 'SET_COLOR_SCHEME';
